/* © Facilogi. See COPYRIGHT file for full copyright & licensing details. */

/* Le dessin Solar d'une ligature Material ( Fred, 02/10/2026 : la Console suit le design
   system du desktop ). Meme table que `src/Web/Libs/ActionIcon.ts` cote desktop, plus les
   ligatures propres a la Console. Le code continue d'ecrire des ligatures Material
   ( `Icon: "delete"` ) : ce fichier est le seul a connaitre les deux familles.

   Regle tenue comme au desktop : UN MENU BASCULE ENTIER OU PAS DU TOUT ( `MenuIsSolar` ). */

import { Dictionary } from "@Internal/Contracts";

const SOLAR: Dictionary<string> = {
    access_time: "clock",
    account_circle: "user-circle",
    add: "add",
    add_a_photo: "camera-add",
    add_circle: "add-circle",
    add_circle_outline: "add-circle",
    add_link: "link",
    alarm: "alarm",
    align_horizontal_left: "align-left",
    align_horizontal_right: "align-right",
    all_inbox: "inbox",
    alternate_email: "at",
    android: "mobile",
    apartment: "building",
    apps: "dashboard",
    archive: "archive",
    arrow_back: "arrow-left",
    arrow_downward: "arrow-down",
    arrow_drop_down: "chevron-down",
    arrow_drop_up: "chevron-up",
    arrow_forward: "arrow-right",
    assignment: "clipboard-text",
    attach_file: "paperclip",
    auto_awesome: "sparkles",
    auto_fix_high: "magic-wand",
    autorenew: "refresh",
    badge: "user-id",
    bar_chart: "chart",
    block: "forbidden",
    bolt: "bolt",
    bookmark_add: "bookmark",
    branding_watermark: "subtitles",
    brightness_2: "moon",
    broken_image: "image-broken",
    cake: "cake",
    calendar_today: "calendar",
    call_end: "call-end",
    campaign: "megaphone",
    card_membership: "card",
    chat: "chat",
    chat_bubble_outline: "chat",
    check: "check",
    check_box: "check-square",
    check_circle: "check",
    chevron_left: "chevron-left",
    chevron_right: "chevron-right",
    clear: "close-circle",
    close: "close",
    cloud_upload: "cloud-upload",
    confirmation_number: "ticket",
    content_copy: "copy",
    corporate_fare: "building",
    create_new_folder: "folder-add",
    credit_card: "card",
    dark_mode: "moon",
    dashboard: "dashboard",
    date_range: "calendar",
    delete: "delete",
    delete_forever: "delete",
    description: "document",
    desktop_mac: "monitor",
    domain: "building",
    done: "check",
    download: "download",
    drafts: "mail-opened",
    drag_handle: "menu-lines",
    drag_indicator: "reorder",
    edit: "edit",
    email: "mail",
    error_outline: "danger-circle",
    euro: "euro",
    event: "calendar",
    event_available: "calendar-check",
    expand_less: "chevron-up",
    expand_more: "chevron-down",
    fact_check: "clipboard-check",
    file_copy: "copy",
    file_download: "download",
    file_upload: "upload",
    filter_list: "tuning",
    folder: "folder",
    folder_open: "folder-open",
    format_bold: "text-bold",
    format_clear: "eraser",
    format_color_fill: "paint",
    format_color_text: "palette",
    format_italic: "text-italic",
    format_list_bulleted: "list",
    format_underlined: "text-underline",
    forward: "forward",
    grade: "star",
    grid_view: "grid",
    group: "user-group",
    groups: "user-group",
    help: "question",
    help_outline: "question",
    history: "history",
    home: "house",
    home_work: "house",
    hourglass_empty: "hourglass",
    how_to_reg: "user-check",
    https: "lock",
    image: "image",
    image_not_supported: "image-broken",
    import_export: "import-export",
    info: "info",
    info_outline: "info",
    insert_drive_file: "file",
    keyboard_arrow_down: "chevron-down",
    keyboard_arrow_left: "chevron-left",
    keyboard_arrow_right: "chevron-right",
    keyboard_arrow_up: "chevron-up",
    language: "world",
    layers: "layers",
    link: "link",
    link_off: "unlink",
    local_movies: "movie",
    local_offer: "tag",
    location_on: "place",
    lock: "lock",
    logout: "logout",
    mail: "mail",
    mail_outline: "mail",
    mark_email_read: "mail-opened",
    menu_book: "book",
    merge_type: "merge",
    mood: "smile",
    more_horiz: "more-horiz",
    notes: "note",
    notifications: "bell",
    notifications_none: "bell",
    open_in_new: "external-link",
    payment: "card",
    people: "user-group",
    perm_media: "media",
    person: "user",
    person_add: "user-plus",
    person_outline: "user",
    person_remove: "user-minus",
    phone: "phone",
    phone_iphone: "mobile",
    photo_library: "media",
    picture_as_pdf: "file-text",
    place: "place",
    play_circle: "play-circle",
    play_circle_outline: "play-circle",
    print: "printer",
    public: "world",
    publish: "upload",
    push_pin: "pin",
    query_builder: "clock",
    receipt: "receipt",
    receipt_long: "receipt",
    redo: "redo",
    refresh: "refresh",
    remove: "minus",
    remove_circle_outline: "minus",
    repeat: "repeat",
    replay: "replay",
    reply: "reply",
    reply_all: "reply-all",
    room: "place",
    save: "diskette",
    schedule: "clock",
    school: "academic-cap",
    screen_share: "screen-share",
    search: "search",
    sell: "tag-price",
    send: "send",
    settings: "settings",
    share: "share",
    smartphone: "mobile",
    star: "star",
    sticky_note_2: "note",
    store: "shop",
    storefront: "shop-2",
    swap_horiz: "swap",
    sync: "refresh",
    tablet_mac: "tablet",
    text_snippet: "document-text",
    thumb_down: "dislike",
    thumb_up: "like",
    tune: "tuning",
    unarchive: "unarchive",
    undo: "undo",
    unfold_more: "unfold",
    upload_file: "upload",
    videocam: "videocamera",
    view_list: "list",
    visibility: "show",
    visibility_off: "hide",
    vpn_key: "key",
    warning: "danger-triangle",
    warning_amber: "danger-triangle",
    whatshot: "flame",
    wifi_tethering: "wifi-router",
    zoom_in: "zoom-in"
};

export function SolarIcon( ligature?: string ): string | undefined {
    return ligature === undefined ? undefined : SOLAR[ ligature.trim() ];
}

/* Every drawn icon of a menu has its Solar drawing ( empty entries do not count ). */
export function MenuIsSolar( icons: ( string | undefined )[] ): boolean {
    const drawn = icons.filter( ( icon ): boolean => icon !== undefined && icon !== "" );

    return drawn.length > 0 && drawn.every( ( icon ): boolean => SolarIcon( icon ) !== undefined );
}
